export const CURRENCY_DEFAULT = 'GBP';
export const STRIPE_MERCHANT_IDENTIFIER = 'merchant.com.simlocal.esim.travel';
export const STRIPE_MERCHANT_COUNTRY_CODE = 'IR';
